/* tslint:disable */
/* eslint-disable */
/**
 * Melco Fusion APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FusionMelcoFusionModelsUpdateProductionStatus
 */
export interface FusionMelcoFusionModelsUpdateProductionStatus {
    /**
     * 
     * @type {number}
     * @memberof FusionMelcoFusionModelsUpdateProductionStatus
     */
    production_status?: number;
}

export function FusionMelcoFusionModelsUpdateProductionStatusFromJSON(json: any): FusionMelcoFusionModelsUpdateProductionStatus {
    return FusionMelcoFusionModelsUpdateProductionStatusFromJSONTyped(json, false);
}

export function FusionMelcoFusionModelsUpdateProductionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FusionMelcoFusionModelsUpdateProductionStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'production_status': !exists(json, 'production_status') ? undefined : json['production_status'],
    };
}

export function FusionMelcoFusionModelsUpdateProductionStatusToJSON(value?: FusionMelcoFusionModelsUpdateProductionStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'production_status': value.production_status,
    };
}


